'use client';

import { useEffect } from 'react';

import { applyThemeFromQuery } from '@utils/themeFromQuery';

/** Runs `applyThemeFromQuery()` once on mount (`?theme=` / `?data-theme=`). */
const ThemeQueryEffect = () => {
  useEffect(() => {
    applyThemeFromQuery();
  }, []);

  return null;
};

export default ThemeQueryEffect;
